import { createAction } from '@/utility/actions';

import { GET_LOCATIONS } from './types';

export const getLocations = createAction(GET_LOCATIONS);

export default { getLocations };
